import numeral from 'numeral'

import { getLaneFromStops } from './getLaneFromStops'

function getBidDescription(stops, price) {
  const lane = getLaneFromStops(stops)
  const formattedPrice = numeral(price).format('$0,0')
  return `${lane} (${formattedPrice})`
}

export { getBidDescription }
